import DialogControl from '@office-start/dialog-control';
import { useLocStrings } from '@office-start/loc-service';
import { useObservable } from '@office-start/use-observable-hook-utility';
import React from 'react';
import { closeConfirmationDialog, observeConfirmationDialog, } from './ConfirmationDialogOperations';
export var ConfirmationDialogComponent = function () {
    var _a;
    var dialog = useObservable(observeConfirmationDialog());
    var locStrings = useLocStrings().data;
    var resources = locStrings === null || locStrings === void 0 ? void 0 : locStrings.confirmationDialogResources;
    if (!resources || !dialog) {
        return null;
    }
    var actions = {
        actions: [
            {
                id: 'cancel',
                onClick: closeConfirmationDialog,
                title: resources.cancelButtonTitle,
                primary: false,
            },
            {
                id: 'confirm',
                onClick: function () {
                    dialog.action();
                    closeConfirmationDialog();
                },
                title: dialog.affirmationButtonTitle,
                primary: true,
            },
        ],
    };
    return (React.createElement(DialogControl, { actions: actions, closeButtonAriaLabel: resources.closeButtonLabel, text: dialog.confirmationText, onClose: closeConfirmationDialog, title: (_a = dialog.dialogTitle) !== null && _a !== void 0 ? _a : resources.confirmationDialogTitle, useFluentTheme: true }));
};
//# sourceMappingURL=ConfirmationDialogComponent.js.map